module.exports = __webpack_public_path__ + "static/media/cummulativeExam.c515779f.png";